import jQuery from "jquery";
import {ACTION, Events} from '../events'
import {VARS} from '../vars'
import 'bootstrap/js/dist/modal';

jQuery(document).ready(function ($) {

    let cookiesGate = {

        cookies: {'necessary': null, 'functional': null, 'statistical': null, 'marketing': null},

        $visibleModal: {},
        $cookiesInfo: $('.modal.cookies-info'),
        $cookiesSettings: $('.modal.cookies-settings'),
        $showCookiesSetup: $('.show-cookies-setup'),
        cookieExpire: 365 * 3,

        init: function () {
            this.readCookies();
            this.initListeners();
            if (!this.isSetupFinished())
                this.showModal(this.$cookiesInfo);
            else
               this.populateData();

        },

        isSetupFinished: function () {
            return (this.cookies.necessary === "accepted")
        },

        initListeners: function () {
            this.$cookiesSettings.find('.accept').on("click", () => {
                this.acceptAll()
                this.hideModal();
            });
            this.$cookiesInfo.find('.accept').on("click", () => {
                this.acceptAll()
                this.hideModal();
            });
            this.$cookiesInfo.find('.settings').on("click", () => {
                this.showModal(this.$cookiesSettings)
            });
            this.$cookiesSettings.find('.save').on("click", () => {
                this.saveSettings();
                this.hideModal();
            });
            this.$showCookiesSetup.on('click', () => {
                this.showModal(this.$cookiesSettings)
            });

        },

        populateData: function () {
            for (const property in this.cookies) {
                this.$cookiesSettings.find("input#" + property).prop('checked', true);

                if(property === 'necessary')
                    continue;

                if(this.cookies[property] !== 'accepted')
                    this.$cookiesSettings.find("#" + property).prop('checked', false);
            }
        },

        acceptAll: function () {
            for (const property in this.cookies) {
                if( this.$cookiesSettings.find("#" + property).length) {
                    this.createCookie(property, "accepted", this.cookieExpire);
                    this.cookies[property] = "accepted";
                }
            }
            this.populateData();
            this.pushDLEvent('event','cookieConsent');
        },

        saveSettings: function () {
            for (const property in this.cookies) {
                if (this.$cookiesSettings.find("#" + property).prop("checked"))
                    this.createCookie(property, "accepted", this.cookieExpire)
                else
                    this.eraseCookie(property)
            }
            this.pushDLEvent('event','cookieConsent');
        },

        //https://www.quirksmode.org/js/cookies.html
        readCookies: function () {
            for (const property in this.cookies) {
                this.cookies[property] = this.readCookie(property);
            }
        },

        createCookie: function (name, value, days) {
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                var expires = "; expires=" + date.toGMTString();
            } else var expires = "";
            document.cookie = name + "=" + value + expires + "; path=/; SameSite=None; Secure";
        },

        pushDLEvent: function(event, value){
            this.readCookies();
            // console.log('pushDLEvent', {
            //                     event: value,
            //                     data: this.cookies
            //                 });
            //
            try {
                dataLayer.push({
                    event: value,
                    data: this.cookies
                });
            }
            catch (e) {
                console.log(e);
            }
        },
        readCookie: function (name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
        },

        eraseCookie: function (name) {
            this.createCookie(name, "", -1);
        },

        showModal: function ($el) {
            if (this.$visibleModal.length)
                this.hideModal(this.$visibleModal);

            $el.css({'display': 'block', 'opacity': '1'});
            this.$visibleModal = $el;

        },

        hideModal: function (_$el) {
            let $el = _$el;
            if (!$el)
                $el = this.$visibleModal;
            $el.css({'display': 'none', 'opacity': '0'});

            this.$visibleModal = {};
        }
    }

    cookiesGate.init();
});
